import Diagram from './js-sequence-diagrams/sequence-diagram';
import convertRough from '../convertRough';
import './js-sequence-diagrams/sequence-diagram.css';

export default async (input, options = {}) => {
  await Diagram
    .parse(input).drawSVG('sequence-unshow', { ...options, theme: 'simple' });
  const svg = document.getElementById('sequence-unshow').firstChild;
  return convertRough(svg, options);
}